import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { UnidadeMedidaService } from 'src/app/admihair/service/unidade-medida.service';
import { UnidadeMedida } from 'src/app/admihair/api/dto/unidade-medida';
import { FabricanteService } from 'src/app/admihair/service/fabricante.service';
import { Fabricante } from 'src/app/admihair/api/dto/fabricante';
import { DanfeCstOrigemService } from 'src/app/admihair/service/danfe-cst-origem.service';
import { DanfeCstEmpresaService } from 'src/app/admihair/service/danfe-cst-empresa.service';
import { DanfeCsosnService } from 'src/app/admihair/service/danfe-csosn.service';
import { DanfeCfop } from 'src/app/admihair/api/dto/danfe/danfe-cfop';
import { DanfeCfopService } from 'src/app/admihair/service/danfe-cfop.service';
import { DanfeCstPisService } from 'src/app/admihair/service/danfe-cst-pis.service';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { forkJoin } from 'rxjs';
import { DanfeCstOrigem } from 'src/app/admihair/api/dto/danfe/danfe-cst-origem';
import { DanfeCstEmpresa } from 'src/app/admihair/api/dto/danfe/danfe-cst-empresa';
import { DanfeCsosn } from 'src/app/admihair/api/dto/danfe/danfe-csosn';
import { DanfeCstPis } from 'src/app/admihair/api/dto/danfe/danfe-cst-pis';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { ClassificacaoTributariaService } from 'src/app/admihair/service/classificacao-tributaria.service';
import { TributacaoDadosCampos } from 'src/app/admihair/api/dto/tributacao-dados-campos';


@Component({
  selector: 'app-item-produto-editar',
  templateUrl: './item-produto-editar.component.html',
  styleUrls: ['./item-produto-editar.component.scss']
})
export class ItemProdutoEditarComponent extends AdmihairBaseComponent implements OnInit {

  exibirSpinnerTributacao: boolean = false;

  itemProduto?: ItemProduto;
  codigoExistente: boolean = false;

  subgrupos: Subgrupo[] = [];
  subgrupoSelecionado?: Subgrupo | null;
  grupos: SelectItem[] = [];

  tributacaoChecked: boolean = false;
  unidadesMedidas: SelectItem[] = [];
  fabricantes: Fabricante[] = [];

  danfeCstOrigem: SelectItem[] = [];
  danfeCstEmpresa: SelectItem[] = [];
  danfeCsosn: SelectItem[] = [];
  danfeCfop: SelectItem[] = [];
  danfeCstPis: SelectItem[] = [];

  codigoInicial?: string;
  temEstoque: boolean = false;
  listaIndEscala: SelectItem[] = [
    { label: 'S - Sim', value: 'S' },
    { label: 'N - Não', value: 'N' }
  ];
  semCnpj: boolean = false;
  modalFabricante: boolean = false;
  cnpjExiste: boolean = false;
  cadastrarCnpj: boolean = false;
  desabilitarCnpj: boolean = false;
  progressoRequisicao: boolean = false;

  crtDanfeEmpresa?: string;

  exibirDialogValorSugerido: boolean = false;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  percentualFrete: number = 0;
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValor: number = 0;
  valorLucroObtidoAtual: number = 0;
  loadingSpinnerDialog: boolean = false;

  listaCstIbsCbs: String[] = [];
  listaClassTrib: String[] = [];

  constructor(private itemProdutoService: ItemProdutoService,
    private entradaEstoqueService: EntradaEstoqueService,
    private subgrupoService: SubgrupoService,
    private fabricanteService: FabricanteService,
    private tributacaoEmpresaService: TributacaoEmpresaService,
    private unidadeMedidaService: UnidadeMedidaService,
    private danfeCstOrigemService: DanfeCstOrigemService,
    private danfeCstEmpresaService: DanfeCstEmpresaService,
    private danfeCsosnService: DanfeCsosnService,
    private danfeCfopService: DanfeCfopService,
    private danfeCstPisService: DanfeCstPisService,
    private custoService: CustoService,
    private classificacaoTributariaService: ClassificacaoTributariaService,
    utilStorageService: UtilStorageService,
    erroService: ErroService,
    router: Router,
    _activatedRoute: ActivatedRoute) {
    super(erroService, utilStorageService, router, _activatedRoute);
  }

  ngOnInit(): void {
    this.exibirSpinnerPrincipal = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PRODUTO');
    this.carregarIdUrl();
    if (this.permissaoEditar) {
      this.carregarGrupos();
    }
  }

  onTabChange(event: any) {
    const index = event.index;

    if (index === 1) {
      this.carregarTributacao();
    }
  }


  carregarGrupos() {
    this.subgrupoService.listarSubgruposProdutoPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Subgrupo[]) => {
        this.grupos = data.map(item => (
          { label: `${item.grupo?.descricao} - ${item.descricao}`, value: item }
        ));
        this.buscarFabricantes();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  buscarFabricantes() {
    this.fabricanteService.listarFabricantesPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Fabricante[]) => {
        this.fabricantes = data;
        this.buscarUnidadesMedidas();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarUnidadesMedidas() {
    this.unidadeMedidaService.listarTodas().subscribe({
      next: (data: UnidadeMedida[]) => {
        this.unidadesMedidas = data.map(item => ({ label: `${item.simbolo} - ${item.descricao}`, value: item.simbolo }));
        this.carregarItemProduto();
      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarItemProduto() {
    this.itemProdutoService.buscarItemProdutoPorId(this.idParametroUrl).subscribe({
      next: (data: ItemProduto) => {
        this.itemProduto = data;
        this.codigoInicial = data.codigo;
        if (this.itemProduto.estoqueAtual && this.itemProduto.estoqueAtual > 0) {
          this.temEstoque = true;
        }
        if (!this.itemProduto.fabricante?.cnpj) {
          this.semCnpj = true;
        } else {
          this.desabilitarCnpj = true;
          this.semCnpj = false;
        }
        this.subgrupoSelecionado = data.subgrupo;
        this.exibirSpinnerPrincipal = false;

      },
      error: (err: any) => {
        this.exibirSpinnerPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarTributacao() {
    this.exibirSpinnerTributacao = true;
    this.buscarCrtDanfeEmpresa();
  }


  buscarCrtDanfeEmpresa() {
    this.tributacaoEmpresaService.buscarCrtEmpresaDanfe(this.getEmpresa().id, this.getEmpresa().cnpjCpf).subscribe({
      next: (data: string) => {
        this.crtDanfeEmpresa = data;
        this.carregarCfop();
      },
      error: (err: any) => {
        this.exibirSpinnerTributacao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarCfop() {
    let cstCsosn;
    if (this.crtDanfeEmpresa === 'SIMPLES_NACIONAL') {
      cstCsosn = this.itemProduto?.csosn;
    } else if (this.crtDanfeEmpresa === 'SN_EXCESSO_SUBLIMITE' || this.crtDanfeEmpresa === 'REGIME_NORMAL') {
      cstCsosn = this.itemProduto?.cstTributIcms;
    }

    this.danfeCfopService.listarPorCstCsosn(cstCsosn).subscribe({
      next: (data: DanfeCfop[]) => {
        this.danfeCfop = data.map(item => ({ label: item.descricao, value: item.codigo }))
        this.carregarDanfe();
      },
      error: (err: any) => {
        this.exibirSpinnerTributacao = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  recarregarCfop(campo?: string) {
    if (campo === 'CSOSN' && this.crtDanfeEmpresa === 'SIMPLES_NACIONAL') {
      this.carregarCfop();
    }
    if (campo === 'CST' && (this.crtDanfeEmpresa === 'SN_EXCESSO_SUBLIMITE'
      || this.crtDanfeEmpresa === 'REGIME_NORMAL')) {
      this.carregarCfop();
    }
  }

  carregarDanfe() {
    forkJoin([
      this.danfeCstOrigemService.listar(),
      this.danfeCstEmpresaService.listar(),
      this.danfeCsosnService.listar(),
      this.danfeCstPisService.listar()
    ]).subscribe({
      next: ([danfeCstOrigem, danfeCstEmpresa, danfeCsosn, danfeCstPis]:
        [DanfeCstOrigem[], DanfeCstEmpresa[], DanfeCsosn[], DanfeCstPis[]]) => {
        this.danfeCstOrigem = this.preencherSelectItem(danfeCstOrigem);
        this.danfeCstEmpresa = this.preencherSelectItem(danfeCstEmpresa);
        this.danfeCsosn = this.preencherSelectItem(danfeCsosn);
        this.danfeCstPis = this.preencherSelectItem(danfeCstPis);

        this.carregarDadosClassificacaoTributaria();
      },
      error: (err: any) => {
        this.exibirSpinnerTributacao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  preencherSelectItem<T extends { descricao?: string; codigo?: string }>(items: T[]): SelectItem[] {
    return items.map(item => (
      {
        label: item.descricao,
        value: item.codigo
      }
    ));
  }

  carregarDadosClassificacaoTributaria() {
    this.classificacaoTributariaService.obterDadosCamposTributacao().subscribe({
      next: (data: TributacaoDadosCampos) => {
        this.listaClassTrib = data.listaClassTrib ?? [];
        this.listaCstIbsCbs = data.listaCstIbsCbs ?? [];
        this.exibirSpinnerTributacao = false;
      },
      error: (err: any) => {
        this.exibirSpinnerTributacao = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  atualizar() {
    this.progressoRequisicao = true;
    if (this.itemProduto) {
      this.itemProduto.descricao = FormatacaoUtil
        .removerCaracteresEspeciais(this.itemProduto.descricao);
    }

    this.itemProdutoService.atualizarItemProduto(this.idParametroUrl, this.itemProduto).subscribe({
      next: (data: ItemProduto) => {
        this.itemProduto = data;
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });

    if (this.cadastrarCnpj) {
      if (this.itemProduto?.fabricante && this.itemProduto.fabricante.id) {
        const id = this.itemProduto.fabricante.id;
        const fabricante = this.itemProduto.fabricante;
        this.fabricanteService.atualizar(id, fabricante).subscribe({
          next: () => {
            this.cadastrarCnpj = false;
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });

      }
    }
  }


  buscarCnpjFabricante() {
    const cnpj = this.itemProduto?.fabricante?.cnpj;
    if (cnpj && cnpj.length === 14) {
      this.fabricanteService.buscarPorEmpresaECnpj(this.getEmpresa().id, cnpj).subscribe({
        next: () => {
          this.cnpjExiste = true;
          this.semCnpj = false;
          this.cadastrarCnpj = false;
        },
        error: (err: any) => {
          if (err.status == '404') {
            this.cnpjExiste = false;
            this.semCnpj = false;
            this.cadastrarCnpj = true;
          }
        }
      });
    } else {
      this.cnpjExiste = false;
      this.semCnpj = true;
      this.cadastrarCnpj = false;
    }
  }


  verificarCodigoExistente(valor: string) {
    if (valor) {
      if (valor !== this.codigoInicial) {
        this.itemProdutoService.codigoExistentePorEmpresa(this.getEmpresa().id, valor).subscribe({
          next: (data: any) => {
            this.codigoExistente = data;
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      } else {
        this.codigoExistente = false;
      }
    } else {
      this.codigoExistente = false;
    }
  }

  abrirUrlProduto() {
    window.open(this.itemProduto?.urlDetalheProduto, '_blank');
  }



  abrirDialogValorSugerido() {
    this.exibirDialogValorSugerido = true;
    this.definirValoresPadrao();
    this.obterCustos();
  }


  definirValoresPadrao() {
    this.novoValor = 0;
    this.valorLucroDesejado = (this.itemProduto?.valorCompra ?? 0) * ((this.itemProduto?.lucro ?? 0) / 100);
    this.valorLucroObtido = 0;
    this.valorSugerido = 0;
  }

  obterCustos() {
    this.loadingSpinnerDialog = true;
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.buscarPercentualFrete();
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarPercentualFrete() {
    this.entradaEstoqueService.buscarPercentualFreteUltimaEntrada(
      this.getEmpresa().id,
      this.itemProduto?.id
    ).subscribe({
      next: (data: number) => {
        this.percentualFrete = data;
        this.calcularLucroObtidoAtual();
        this.calcularValorSugerido();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  private calcularValorCompra(): number {
    const valorCompra = this.itemProduto?.valorCompra ?? 0;
    const quantidade = this.itemProduto?.quantidadeUnidadeMedida ?? 1;

    if (quantidade > 1) {
      return valorCompra / quantidade;
    }
    return valorCompra;
  }

  private calcularValorFrete(valorCompra: number): number {
    return valorCompra * (this.percentualFrete / 100);
  }

  private calcularPercentualCusto(): number {
    const custoFixo = this.custoMedio?.custoFixo ?? 0;
    const comissao = this.itemProduto?.comissaoVenda ?? 0;
    const imposto = this.custoMedio?.imposto ?? 0;
    return custoFixo + comissao + imposto;
  }

  calcularValorSugerido(): void {
    if (!this.itemProduto?.lucro) {
      this.valorSugerido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorLucroDesejado = valorCompra * (this.itemProduto.lucro / 100);
    const valorComposicao = valorCompra + valorFrete + valorLucroDesejado;

    const percentualCusto = this.calcularPercentualCusto();
    const valorInicial = valorComposicao + (percentualCusto * valorComposicao / 100);
    const diferencaComposicao = (valorInicial - valorComposicao) * (percentualCusto / 100);

    const valorCalculado = valorInicial + diferencaComposicao + (diferencaComposicao * percentualCusto / 100);
    this.valorSugerido = valorCalculado;
  }

  calcularLucroObtidoAtual(): void {
    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const valorVenda = this.itemProduto?.valorVenda ?? 0;
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = valorVenda * (percentualCusto / 100);
    this.valorLucroObtidoAtual = valorVenda - valorCompra - valorFrete - valorCustoReais;
  }

  calcularLucroObtido(valor?: number): void {
    this.novoValor = valor ?? 0;

    if (this.novoValor <= 0) {
      this.valorLucroObtido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = this.calcularValorFrete(valorCompra);
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = this.novoValor * (percentualCusto / 100);
    this.valorLucroObtido = this.novoValor - valorCompra - valorFrete - valorCustoReais;
  }



  confirmarNovoValor() {
    if (this.itemProduto) {
      this.itemProduto.valorVenda = this.novoValor;
    }
    this.exibirDialogValorSugerido = false;
  }

}
